import { useState } from 'react';

export type ViewMode = 'cards' | 'table';

function getCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? decodeURIComponent(match[2]) : null;
}

function setCookie(name: string, value: string, days = 365) {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)};expires=${expires};path=/;SameSite=Lax`;
}

/**
 * Persists the user's preferred view mode (cards vs table) in a cookie.
 * @param key - Unique cookie name for this page (e.g. 'captures_view', 'catalog_view')
 * @param defaultMode - Default view mode if no cookie is set
 */
export function useViewMode(key: string, defaultMode: ViewMode = 'cards'): [ViewMode, (mode: ViewMode) => void] {
  const [mode, setModeState] = useState<ViewMode>(() => {
    const stored = getCookie(key);
    if (stored === 'cards' || stored === 'table') return stored;
    return defaultMode;
  });

  const setMode = (newMode: ViewMode) => {
    setModeState(newMode);
    setCookie(key, newMode);
  };

  return [mode, setMode];
}
